export const ptBR = {
  // Navigation
  nav: {
    dashboard: "Dashboard",
    nutrition: "Nutrição",
    workouts: "Treinos",
    progress: "Progresso",
    analytics: "Analytics",
    ranking: "Ranking",
    social: "Social",
    report: "Relatório",
    help: "Ajuda",
    timer: "Timer",
    pricing: "Planos",
    profile: "Perfil",
    logout: "Sair",
    login: "Entrar",
    signup: "Criar conta",
    home: "Início",
    macros: "Macros",
    more: "Mais",
    moreOptions: "Mais opções",
  },
  // Dashboard
  dashboard: {
    welcome: "Olá, {{name}}! 👋",
    welcomeGeneric: "Olá! 👋",
    subtitle: "Aqui está seu resumo do dia",
    waterTracker: "Água",
    streak: "Sequência",
    gamification: "Pontos",
    dailyCheckin: "Check-in Diário",
    microGoals: "Micro Metas",
    weeklySummary: "Resumo Semanal",
    aiInsights: "Insights IA",
    weeklyChallenges: "Desafios da Semana",
    calorieCounter: "Calorias",
    features: "Funcionalidades",
  },
  // Common
  common: {
    loading: "Carregando...",
    save: "Salvar",
    cancel: "Cancelar",
    delete: "Excluir",
    edit: "Editar",
    create: "Criar",
    generate: "Gerar",
    start: "Iniciar",
    stop: "Parar",
    pause: "Pausar",
    reset: "Zerar",
    close: "Fechar",
    back: "Voltar",
    next: "Próximo",
    previous: "Anterior",
    confirm: "Confirmar",
    yes: "Sim",
    no: "Não",
    or: "ou",
    and: "e",
    of: "de",
    to: "até",
    from: "de",
    days: "dias",
    hours: "horas",
    minutes: "minutos",
    seconds: "segundos",
    points: "pontos",
    total: "total",
    average: "média",
    noData: "Sem dados",
    error: "Erro",
    success: "Sucesso",
    share: "Compartilhar",
    download: "Baixar",
    copy: "Copiar",
    copied: "Copiado!",
    optional: "opcional",
    required: "obrigatório",
    add: "Adicionar",
    remove: "Remover",
    saving: "Salvando...",
    updating: "Atualizando...",
    generating: "Gerando...",
    sending: "Enviando...",
    searching: "Buscando...",
  },
  // Timer
  timer: {
    title: "Timer de Treino",
    subtitle: "Cronômetro, contagem regressiva, intervalos e circuitos",
    intervals: "Intervalos",
    circuit: "Circuito",
    countdown: "Regressivo",
    stopwatch: "Cronômetro",
    work: "Trabalho",
    rest: "Descanso",
    rounds: "Rounds",
    round: "Round",
    done: "Finalizado!",
    readyToStart: "Pronto para começar",
    laps: "Voltas",
    lap: "Volta",
    timeUp: "Tempo esgotado!",
    startCircuit: "Começar Circuito",
    restart: "Recomeçar",
    exerciseName: "Nome do exercício",
    addExercise: "Adicionar Exercício",
    restBetween: "Descanso (s)",
    restBetweenRounds: "Desc. Round (s)",
    totalEstimate: "total",
  },
  // Nutrition
  nutrition: {
    title: "Plano Alimentar com IA",
    subtitle: "Cardápios personalizados gerados por inteligência artificial",
    generateNew: "Gerar Novo Plano",
    generating: "Gerando plano...",
    noPlans: "Nenhum plano criado ainda",
    noPlansDesc: "Clique em 'Gerar Novo Plano' acima para criar seu primeiro plano alimentar personalizado com IA",
    weightRequired: "Peso necessário",
    seeRecipe: "Ver Receita",
    ingredients: "Ingredientes",
    instructions: "Modo de Preparo",
    prepTime: "Tempo de preparo",
    difficulty: "Dificuldade",
    easy: "fácil",
    medium: "médio",
    hard: "difícil",
    planName: "Nome do plano (opcional)",
    planNamePlaceholder: "Ex: Dieta Low Carb...",
  },
  // Workouts
  workouts: {
    title: "Plano de Treino com IA",
    subtitle: "Treinos personalizados gerados por inteligência artificial",
    generateNew: "Gerar Novo Plano",
    generating: "Gerando plano...",
    noPlans: "Nenhum plano criado ainda",
    planName: "Nome do plano (opcional)",
    planNamePlaceholder: "Ex: Treino Upper/Lower...",
    workoutComplete: "✓ Treino Completo",
    markWorkoutComplete: "Marcar treino como completo",
  },
  // Progress
  progress: {
    title: "Seu Progresso",
    subtitle: "Acompanhe sua evolução física",
    addRecord: "Novo Registro",
    weight: "Peso",
    bodyFat: "Gordura Corporal",
    muscleMass: "Massa Muscular",
    photos: "Fotos",
    noRecords: "Nenhum registro ainda",
  },
  // Analytics
  analytics: {
    title: "Analytics & Insights",
    subtitle: "Visualize sua evolução e conquistas",
    exportCSV: "CSV",
    period: "Período",
    overview: "Geral",
    weightTab: "Peso",
    nutritionTab: "Nutrição",
    workoutsTab: "Treinos",
    moodTab: "Humor",
    noData: "Sem dados para visualizar",
    noDataDesc: "Comece a fazer check-ins diários e registrar seu progresso para ver gráficos detalhados",
    noDataInPeriod: "Sem dados neste período",
    viewAllHistory: "Ver todo histórico",
  },
  // Auth
  auth: {
    login: "Entrar",
    signup: "Criar conta",
    email: "E-mail",
    password: "Senha",
    fullName: "Nome completo",
    forgotPassword: "Esqueceu a senha?",
    noAccount: "Não tem uma conta?",
    hasAccount: "Já tem uma conta?",
    loginWithGoogle: "Entrar com Google",
    welcomeTitle: "Bem-vindo ao FitPro",
    welcomeSubtitle: "Sua jornada fitness começa aqui",
    signinTab: "Entrar",
    signupTab: "Criar Conta",
    continueWithGoogle: "Continuar com Google",
    signingIn: "Entrando...",
    creatingAccount: "Criando conta...",
    createAccount: "Criar Conta",
    accountCreated: "Conta criada com sucesso!",
    accountCreatedDesc: "Você já pode fazer login.",
    confirmPasswordLabel: "Confirmar Senha",
    confirmPasswordPlaceholder: "Digite a senha novamente",
    passwordsMatch: "Senhas coincidem ✓",
    passwordsDontMatch: "Senhas não coincidem",
    tooManyAttempts: "Muitas tentativas",
    tooManyAttemptsDesc: "Por favor, aguarde um minuto antes de tentar novamente.",
    passwordsMismatch: "As senhas não coincidem",
    invalidChars: "Caracteres inválidos detectados",
    errorSignup: "Erro ao criar conta",
    errorSignin: "Erro ao fazer login",
    errorGoogleSignin: "Erro ao fazer login com Google",
    termsText: "Ao criar uma conta, você concorda com os",
    termsLink: "Termos de Uso",
    andThe: "e a",
    privacyLink: "Política de Privacidade",
    errorSignout: "Erro ao sair",
  },
  // Profile
  profile: {
    shareTitle: "Meu Perfil",
    saveImage: "Salvar Imagem",
    share: "Compartilhar",
    points: "Pontos",
    streak: "Sequência",
    checkins: "Check-ins",
    imageSaved: "Imagem salva! 📸",
    imageSavedDesc: "Compartilhe nas suas redes!",
    imageError: "Erro ao gerar imagem",
    profileCopied: "Copiado!",
    profileCopiedDesc: "Texto copiado para a área de transferência",
    myProfile: "Meu Perfil",
    friends: "Amigos",
    challenges: "Desafios",
    copyProfileLink: "Copiar link do perfil público",
    linkCopied: "Link copiado! 🔗",
    linkCopiedDesc: "Compartilhe seu perfil público",
    profileNotFound: "Perfil não encontrado",
    profileNotFoundDesc: "O código de amigo informado não existe ou é inválido.",
    goToHome: "Ir para o início",
    startYourJourney: "Comece sua jornada também 🚀",
  },
  // Ranking
  ranking: {
    title: "Ranking",
    subtitle: "Veja quem está no topo",
    yourPosition: "Sua posição",
  },
  // Streak
  streak: {
    title: "Sequência",
    startToday: "Comece sua sequência hoje!",
    greatStart: "Ótimo começo! Continue amanhã!",
    onTrack: "Você está no caminho certo!",
    amazing: "Incrível! Continue assim!",
    unstoppable: "Você é imparável! 🔥",
    nextMilestone: "Próximo marco",
    remaining: "restantes",
    master: "Mestre",
    advanced: "Avançado",
    intermediate: "Intermediário",
    beginner: "Iniciante",
    start: "Começar",
  },
  // Daily Checkin
  checkin: {
    dayRecord: "Registro do Dia",
    trackProgress: "Acompanhe e atualize seu progresso de hoje",
    meals: "Refeições",
    breakfast: "Café da manhã",
    lunch: "Almoço",
    snack: "Lanche",
    dinner: "Jantar",
    mealsComplete: "{{count}}/{{total}} refeições completas",
    workout: "Treino",
    weightOfDay: "Peso do Dia",
    howAreYouFeeling: "Como você está se sentindo?",
    dayNotes: "Notas do Dia",
    dayNotesPlaceholder: "Como foi seu dia? Alguma observação...",
    saveRecord: "Salvar Registro",
    updateRecord: "Atualizar Registro",
    recordSaved: "Registro salvo!",
    recordSavedDesc: "Seu progresso do dia foi atualizado com sucesso.",
    errorSaving: "Erro ao salvar",
    invalidWeight: "Peso inválido",
    invalidWeightDesc: "O peso deve estar entre 20 e 500 kg",
    userNotAuth: "Usuário não autenticado",
    moodGreat: "Ótimo",
    moodGood: "Bom",
    moodOkay: "Ok",
    moodBad: "Ruim",
  },
  // Water Tracker
  water: {
    title: "Água Hoje",
    cupSize: "1 copo = 250ml",
    goal: "Meta: {{amount}}ml",
    add: "Adicionar",
    exceeded: "Você excedeu sua meta em {{amount}}ml. Beber água em excesso pode ser prejudicial.",
    cupsAboveGoal: "⚠️ {{count}} copos acima da meta",
    goalReached: "🎉 Meta atingida!",
    cupsRemaining: "Faltam {{count}} copos",
    removeGlass: "Remover um copo",
    errorSaving: "Erro ao salvar",
  },
  // Navbar
  navbar: {
    toggleTheme: "Alternar tema",
    switchToTheme: "Alternar para tema {{theme}}",
    light: "claro",
    dark: "escuro",
    changeLanguage: "Mudar idioma",
    switchToEnglish: "Switch to English",
    switchToPortuguese: "Mudar para Português",
    rankingGamification: "Ranking & Gamificação",
    helpCenter: "Central de Ajuda",
    settings: "Configurações",
    settingsDesc: "Configure lembretes e notificações do aplicativo",
    signOut: "Sair da conta",
    startNow: "Começar Agora",
  },
  // Help
  help: {
    title: "Central de Ajuda",
    subtitle: "Tire suas dúvidas e aprenda a usar todas as funcionalidades",
    interactiveTour: "Tour Interativo",
    interactiveTourDesc: "Reveja o tutorial passo a passo de todas as funcionalidades do app",
    viewTutorial: "Ver Tutorial",
    foundProblem: "Encontrou um problema?",
    foundProblemDesc: "Reporte bugs ou envie sugestões diretamente pelo WhatsApp",
    reportBug: "Reportar Bug",
    allCategories: "Todas",
    faq: "Perguntas Frequentes",
    quickTips: "Dicas Rápidas",
    categories: {
      checkin: "Check-in",
      hydration: "Hidratação",
      nutrition: "Nutrição",
      macros: "Macros",
      workout: "Treino",
      aiCoach: "IA Coach",
      social: "Social",
      challenges: "Desafios",
      gamification: "Gamificação",
      ranking: "Ranking",
      progress: "Progresso",
      notifications: "Notificações",
    },
    faqItems: [
      { category: "checkin", question: "Como faço o check-in diário?", answer: "No Dashboard, você encontra o card de Check-in Diário. Clique para registrar seu peso, humor, se treinou e quais refeições fez. Fazer check-in todo dia ajuda a manter sua sequência e ganhar pontos!" },
      { category: "checkin", question: "O que acontece se eu esquecer de fazer o check-in?", answer: "Sua sequência de dias consecutivos será resetada, mas não se preocupe! Você pode recomeçar a qualquer momento. Tente criar um hábito fazendo o check-in sempre no mesmo horário." },
      { category: "hydration", question: "Quantos copos de água devo beber por dia?", answer: "Recomendamos 8 copos de água por dia (cerca de 2 litros). Use o tracker de água no Dashboard para acompanhar. Cada copo registrado conta para sua meta semanal!" },
      { category: "nutrition", question: "Como funciona a análise de alimentos por foto?", answer: "Na aba Macros, clique no botão da câmera para tirar uma foto do seu prato. Nossa IA analisa a imagem e estima automaticamente as calorias e macronutrientes. Você pode ajustar os valores se necessário." },
      { category: "nutrition", question: "Posso substituir alimentos do plano alimentar?", answer: "Sim! Em cada refeição do seu plano, você pode usar o botão de substituição para encontrar alimentos similares com macros parecidos. A IA sugere opções saudáveis equivalentes." },
      { category: "nutrition", question: "Como gero um plano alimentar personalizado?", answer: "Na aba Nutrição, preencha seus dados (peso, objetivo, restrições) e clique em 'Gerar Plano Alimentar'. A IA cria um plano completo com todas as refeições do dia, respeitando suas preferências e restrições alimentares." },
      { category: "nutrition", question: "Como edito meu plano alimentar?", answer: "No plano fixado, use o botão 'Editar Plano' para pedir alterações à IA (como trocar um alimento ou ajustar quantidades), ou use 'Edição Manual' para fazer alterações pontuais diretamente nos alimentos." },
      { category: "macros", question: "Como registro minhas refeições e calorias?", answer: "Na aba Macros, adicione refeições manualmente informando nome, calorias e macros. Você também pode usar a câmera para analisar fotos de alimentos, e a IA preenche os valores automaticamente." },
      { category: "macros", question: "O que significam os macronutrientes (P, C, G)?", answer: "P = Proteínas, C = Carboidratos, G = Gorduras. Cada um tem uma função: proteínas ajudam na recuperação muscular, carboidratos fornecem energia, e gorduras são essenciais para hormônios e absorção de vitaminas." },
      { category: "workout", question: "Como gero um plano de treino personalizado?", answer: "Vá até a aba Treinos, escolha o tipo de treino (academia, calistenia, casa ou misto), tempo disponível, e clique em 'Gerar Plano'. A IA cria um treino baseado no seu nível, equipamentos e objetivos." },
      { category: "workout", question: "Como vejo as dicas de execução dos exercícios?", answer: "Em cada exercício do seu plano, há um ícone de informação. Clique nele para ver instruções detalhadas, músculos trabalhados e erros comuns a evitar." },
      { category: "workout", question: "Posso editar exercícios individuais do meu plano?", answer: "Sim! Cada exercício tem um botão de edição. Você pode pedir à IA para substituir por um exercício equivalente, alterar séries/repetições, ou fazer ajustes manuais diretamente." },
      { category: "aiCoach", question: "Como uso o FitCoach IA?", answer: "Acesse o chat do FitCoach IA pelo menu 'Mais' na barra inferior. Você pode fazer perguntas sobre treino, nutrição, suplementação e saúde. O coach responde com base no seu perfil e objetivos." },
      { category: "aiCoach", question: "Existe limite de uso da IA?", answer: "Sim, cada funcionalidade de IA tem um limite diário de uso gratuito para garantir qualidade para todos. O badge de uso (ex: 2/5) mostra quantas vezes você já usou e o limite do dia." },
      { category: "social", question: "Como adiciono amigos no app?", answer: "Na aba Social, você pode compartilhar seu código de amigo ou buscar amigos pelo código deles. Aceite convites de amizade para competir em desafios e comparar progresso!" },
      { category: "social", question: "Como funcionam os desafios entre amigos?", answer: "Você pode criar desafios personalizados com seus amigos: quem treina mais dias, bebe mais água, etc. O vencedor ganha pontos bônus de gamificação!" },
      { category: "challenges", question: "Como funcionam os desafios semanais?", answer: "Toda semana surgem novos desafios automáticos (ex: 'Beba 56 copos de água', 'Faça 5 check-ins'). Complete-os para ganhar pontos bônus e subir de nível mais rápido!" },
      { category: "gamification", question: "Como funciona o sistema de pontos e níveis?", answer: "Você ganha pontos por ações como fazer check-in, completar treinos, bater metas de água, etc. Os pontos acumulados determinam seu nível (tier). Existem 10 níveis, desde 'Sedentário Arrependido' até 'Imortal Fitness'!" },
      { category: "gamification", question: "Como subo de divisão dentro do meu nível?", answer: "Cada nível tem 4 divisões (4 a 1). Conforme você acumula pontos, sobe de divisão automaticamente. Ao atingir pontos suficientes, você sobe para o próximo nível!" },
      { category: "ranking", question: "Como funciona o ranking?", answer: "O ranking mostra os usuários com mais pontos de gamificação. Sua posição é atualizada automaticamente conforme você ganha pontos. Compete com a comunidade para chegar ao topo!" },
      { category: "progress", question: "Como acompanho minha evolução de peso?", answer: "Na aba Progresso, você vê gráficos do seu peso ao longo do tempo. Registre seu peso no check-in diário ou diretamente na aba de progresso para ver tendências semanais e mensais." },
      { category: "progress", question: "O que é o Relatório de Progresso?", answer: "O Relatório é um resumo visual animado do seu progresso com estatísticas de check-ins, peso, água e treinos. Você pode compartilhar como imagem nas redes sociais para mostrar sua evolução!" },
      { category: "notifications", question: "Como configuro lembretes de água e treino?", answer: "Acesse Configurações de Notificação pelo menu 'Mais'. Lá você pode ativar/desativar lembretes de água, treino e check-in, além de definir horários de início e fim dos alertas." },
    ],
    tips: [
      "Faça check-in todo dia para manter sua sequência",
      "Beba um copo de água a cada 1-2 horas",
      "Use a câmera para registrar refeições rapidamente",
      "Veja as dicas de execução antes de cada exercício",
      "Mantenha a constância para subir de nível mais rápido",
      "Pese-se sempre no mesmo horário para maior precisão",
      "Pergunte ao FitCoach IA sobre dúvidas de treino e dieta",
      "Desafie amigos para se manter motivado!",
    ],
  },
  // Onboarding
  onboarding: {
    mainGoal: "Qual é seu objetivo principal?",
    mainGoalDesc: "Escolha o foco da sua jornada",
    loseWeight: "Emagrecer",
    loseWeightDesc: "Perder gordura e definir o corpo",
    gainMass: "Ganhar Massa",
    gainMassDesc: "Hipertrofia e ganho muscular",
    maintain: "Manter Forma",
    maintainDesc: "Manter o peso e a saúde atual",
    generalHealth: "Saúde Geral",
    generalHealthDesc: "Melhorar disposição e bem-estar",
    aboutYou: "Conte-nos sobre você",
    aboutYouDesc: "Informações básicas para personalizar seu plano",
    age: "Idade",
    gender: "Gênero",
    male: "Masculino",
    female: "Feminino",
    other: "Outro",
    preferNotSay: "Prefiro não dizer",
    select: "Selecione",
    height: "Altura (cm) - opcional",
    currentWeight: "Peso Atual (kg)",
    targetWeight: "Peso Meta (kg) - opcional",
    weightAndGoal: "Peso atual e meta",
    weightAndGoalDesc: "Nos ajuda a calcular suas necessidades",
    experienceLevel: "Nível de experiência",
    experienceLevelDesc: "Para ajustar a intensidade dos treinos",
    beginner: "Iniciante",
    beginnerDesc: "Nunca treinei ou treino há menos de 6 meses",
    intermediate: "Intermediário",
    intermediateDesc: "Treino há 6 meses - 2 anos",
    advanced: "Avançado",
    advancedDesc: "Treino há mais de 2 anos",
    activityLevel: "Nível de atividade no dia a dia",
    sedentary: "Sedentário",
    sedentaryDesc: "Trabalho sentado, pouca caminhada",
    moderate: "Moderado",
    moderateDesc: "Caminho bastante, trabalho ativo",
    active: "Ativo",
    activeDesc: "Muito ativo fisicamente no dia a dia",
    workoutAvailability: "Disponibilidade para treino",
    workoutAvailabilityDesc: "Quando e como você pode treinar",
    daysPerWeek: "Dias por semana",
    availableEquipment: "Equipamentos disponíveis",
    fullGym: "Academia completa",
    homeDumbbells: "Halteres em casa",
    bands: "Elásticos/Faixas",
    bodyweight: "Apenas peso corporal",
    pullUpBar: "Barra fixa",
    sleepRecovery: "Sono e recuperação",
    sleepRecoveryDesc: "Essencial para seus resultados",
    avgSleep: "Média de sono por noite",
    lessThan5h: "Menos de 5 horas",
    moreThan8h: "Mais de 8 horas",
    eating: "Alimentação",
    eatingDesc: "Seus hábitos e restrições alimentares",
    mealsPerDay: "Refeições por dia",
    meals: "refeições",
    allergies: "Alergias alimentares",
    gluten: "Glúten",
    lactose: "Lactose",
    nuts: "Nozes/Amendoim",
    seafood: "Frutos do Mar",
    eggs: "Ovos",
    soy: "Soja",
    noAllergies: "Nenhuma alergia",
    dietaryRestrictions: "Restrições dietéticas",
    noRestrictions: "Sem restrições",
    vegetarian: "Vegetariano",
    vegan: "Vegano",
    biggestChallenge: "Seu maior desafio",
    biggestChallengeDesc: "O que mais te impede de alcançar seus objetivos?",
    consistency: "Manter consistência",
    controlDiet: "Controlar alimentação",
    noTime: "Falta de tempo",
    motivation: "Motivação",
    dontKnow: "Não sei o que fazer",
    injuries: "Lesões/Dores",
    yourMotivation: "Sua motivação",
    yourMotivationDesc: "O que te move a buscar uma vida mais saudável?",
    healthLongevity: "Saúde e longevidade",
    physicalAppearance: "Aparência física",
    moreEnergy: "Mais energia no dia",
    selfEsteem: "Autoestima/Confiança",
    sportPerformance: "Performance esportiva",
    medicalRecommendation: "Recomendação médica",
    injuriesInfo: "Lesões e informações",
    injuriesInfoDesc: "Nos conte se há algo que devemos considerar",
    injuriesPlaceholder: "Ex: Tenho problema no joelho direito...",
    additionalInfo: "Alguma observação adicional?",
    additionalInfoPlaceholder: "Algo mais que devemos saber para personalizar seus planos?",
    finishSetup: "Finalizar e Começar! 🚀",
    settingUp: "Configurando...",
    profileSetup: "Perfil configurado! 🎉",
    profileSetupDesc: "Sua jornada personalizada começa agora",
    errorSaving: "Erro ao salvar",
    ageValidation: "Idade deve estar entre 10 e 120 anos",
    ageRange: "10 - 120 anos",
    heightValidation: "Altura deve estar entre 50 e 280 cm",
    heightRange: "50 - 280 cm",
    weightValidation: "Peso deve estar entre 20 e 350 kg",
    targetWeightValidation: "Peso meta deve estar entre 20 e 350 kg",
  },
  // Social
  social: {
    title: "Social",
    myProfile: "Meu Perfil",
    friends: "Amigos",
    challenges: "Desafios",
  },
  // Pricing
  pricing: {
    back: "Voltar",
    signOut: "Sair",
    disconnected: "Desconectado",
    disconnectedDesc: "Você saiu da sua conta.",
    unlockPotential: "Desbloqueie todo o potencial",
    transformBody: "Transforme seu corpo com",
    premium: "FitPro Premium",
    unlimitedAccess: "Acesso ilimitado ao coach IA, planos personalizados, análise de refeições e muito mais.",
    youArePremium: "Você é Premium!",
    nextBilling: "Próxima cobrança",
    manageSubscription: "Gerenciar Assinatura",
    managing: "Abrindo...",
    monthly: "Mensal",
    yearly: "Anual",
    savePercent: "Economize {{percent}}%",
    perMonth: "/mês",
    perYear: "/ano",
    savingsOf: "Economia de",
    subscribe: "Assinar {{cycle}}",
    processing: "Processando...",
    mostPopular: "Mais Popular",
    yourPlan: "Seu Plano",
    redirectToSignup: "Você será redirecionado para criar uma conta",
    securePayment: "Pagamento seguro via Stripe",
    cancelAnytime: "Cancele quando quiser",
    immediateAccess: "Acesso imediato",
    termsAgree: "Ao assinar, você concorda com nossos Termos de Uso e Política de Privacidade.",
    subscriptionSuccess: "Assinatura realizada! 🎉",
    subscriptionSuccessDesc: "Bem-vindo ao FitPro Premium! Aproveite todos os recursos.",
    checkoutCanceled: "Checkout cancelado",
    checkoutCanceledDesc: "Você pode tentar novamente quando quiser.",
  },
  // Macros Calculator
  macros: {
    title: "Calculadora de Macros",
    subtitle: "Cálculo preciso de calorias e macronutrientes para seu objetivo",
    focusWeightLoss: "Foco em Emagrecimento",
    focusMuscleGain: "Foco em Hipertrofia",
    yourData: "Seus Dados",
    fillInfo: "Preencha suas informações para calcular",
    weight: "Peso (kg)",
    height: "Altura (cm)",
    age: "Idade",
    gender: "Sexo",
    male: "Masculino",
    female: "Feminino",
    activityLevel: "Nível de Atividade",
    sedentary: "Sedentário (pouco ou nenhum exercício)",
    light: "Leve (1-3 dias/semana)",
    moderate: "Moderado (3-5 dias/semana)",
    active: "Ativo (6-7 dias/semana)",
    veryActive: "Muito Ativo (2x por dia)",
    calculate: "Calcular",
    results: "Seus Resultados",
    basedOnProfile: "Baseado no seu perfil e objetivo",
    bmr: "Taxa Metabólica Basal (BMR)",
    tdee: "Gasto Calórico Total (TDEE)",
    dailyGoal: "Meta Calórica Diária",
    forWeightLoss: "Para emagrecimento",
    forMuscleGain: "Para ganho de massa",
    protein: "Proteína",
    carbs: "Carboidratos",
    fat: "Gorduras",
    tip: "Use esses valores como base. Monitore seu progresso e ajuste conforme necessário.",
    awaitingCalc: "Aguardando cálculo",
    fillDataToCalc: "Preencha seus dados ao lado e clique em calcular para ver seus resultados",
  },
  // Calorie Counter
  calories: {
    title: "Contador de Calorias",
    add: "Adicionar",
    registerMeal: "Registrar Refeição",
    photoOrManual: "Tire uma foto ou insira manualmente",
    photoAI: "Foto IA",
    manual: "Manual",
    uploading: "Fazendo upload...",
    clickToPhoto: "Clique para tirar foto ou selecionar imagem",
    mealPhoto: "Foto da refeição",
    additionalInfo: "Informações adicionais (opcional)",
    additionalInfoPlaceholder: "Ex: São 200g de frango com arroz...",
    analyzeAndSave: "Analisar e Salvar",
    analyzing: "Analisando...",
    changePhoto: "Trocar foto",
    mealName: "Nome da refeição",
    caloriesLabel: "Calorias",
    proteinG: "Proteína (g)",
    carbsG: "Carbos (g)",
    fatG: "Gordura (g)",
    notes: "Observações",
    notesPlaceholder: "Notas sobre a refeição...",
    saveMeal: "Salvar Refeição",
    saving: "Salvando...",
    today: "Hoje",
    noEntries: "Nenhuma refeição registrada hoje",
    noEntriesDesc: "Adicione sua primeira refeição do dia",
    mealRegistered: "Refeição registrada!",
    entryRemoved: "Entrada removida",
    entryRemovedDesc: "A refeição foi removida com sucesso",
    requiredFields: "Campos obrigatórios",
    requiredFieldsDesc: "Nome da refeição e calorias são obrigatórios",
    errorLoading: "Erro ao carregar entradas",
    invalidFile: "Arquivo inválido",
    selectImage: "Por favor, selecione uma imagem",
    errorUpload: "Erro ao fazer upload",
    errorRemoving: "Erro ao remover",
    userNotAuth: "Usuário não autenticado",
  },
  // Gamification
  gamification: {
    yourProgress: "Seu Progresso",
    points: "pontos",
    forNext: "para",
    inRanking: "no Ranking",
    remaining: "Faltam",
    yourJourney: "Sua Jornada Fitness",
    yourPositionIn: "Sua Posição em",
    firstInTier: "Você é o primeiro neste tier!",
    tierLadder: "Escada de Tiers",
    division: "Divisão",
    youAreHere: "Você está aqui",
    conquered: "Conquistado ✓",
    needPoints: "Faltam",
    user: "Usuário",
    you: "você",
  },
  // Progress page
  progressPage: {
    title: "Tracking de Progresso",
    subtitle: "Acompanhe sua evolução ao longo do tempo",
    addRecord: "Adicionar Registro",
    newRecord: "Novo Registro de Progresso",
    newRecordDesc: "Registre suas medidas e acompanhe sua evolução",
    weightKg: "Peso (kg)",
    bodyFatPercent: "Percentual de Gordura (%)",
    muscleMassKg: "Massa Muscular (kg)",
    observations: "Observações",
    observationsPlaceholder: "Como você está se sentindo? Notas sobre treino, alimentação...",
    photos: "Fotos (máx. 3)",
    photo: "Foto",
    saveRecord: "Salvar Registro",
    saving: "Salvando...",
    progressSaved: "Progresso registrado! 📊",
    dataSaved: "Seus dados foram salvos com sucesso",
    noRecords: "Nenhum registro ainda",
    noRecordsDesc: "Comece a registrar seu progresso para acompanhar sua evolução física ao longo do tempo",
    addFirstRecord: "Adicionar Primeiro Registro",
    invalidValue: "Valor inválido",
    weightRange: "O peso deve estar entre 0.1 kg e 500 kg",
    bodyFatRange: "O percentual de gordura deve estar entre 0% e 60%",
    muscleMassRange: "A massa muscular deve estar entre 0.1 kg e 300 kg",
    errorSaving: "Erro ao salvar",
    weight: "Peso",
    bodyFat: "% Gordura",
    muscleMass: "Massa Muscular",
    fileTooLarge: "Arquivo muito grande",
    maxSize: "Máximo 5MB",
  },
  // Workouts page
  workoutsPage: {
    title: "Treinos Personalizados",
    subtitle: "Workouts gerados por IA adaptados ao seu objetivo",
    generateNew: "Gerar Novo Treino",
    generateNewDesc: "Nossa IA vai criar um plano personalizado baseado no seu foco",
    planNameLabel: "Nome do plano (opcional)",
    planNamePlaceholder: "Ex: Treino Push Pull Legs, Treino de Força...",
    planNameHint: "Se não preencher, a IA vai gerar um nome automaticamente",
    descriptionLabel: "Descreva o que você busca no treino (opcional)",
    descriptionPlaceholder: "Ex: Quero exercícios mais focados na perna, ou exercícios mais leves para começar...",
    descriptionHint: "Opcional: a IA vai adaptar o treino à sua realidade",
    trainingType: "Tipo de treino",
    selectType: "Selecione o tipo...",
    gym: "Academia (com aparelhos)",
    calisthenics: "Calistenia (peso corporal)",
    mixed: "Misto (academia + calistenia)",
    home: "Em casa (equipamento mínimo)",
    availableTime: "Tempo disponível (opcional)",
    howLong: "Quanto tempo?",
    min30: "30 minutos",
    min45: "45 minutos",
    hour1: "1 hora",
    hour1_30: "1h30",
    hour2: "2 horas",
    weightRequired: "Peso necessário",
    weightRequiredDesc: "Por favor, informe seu peso atual.",
    invalidWeight: "Peso inválido",
    invalidWeightDesc: "O peso deve estar entre 0.1 e 500kg.",
    invalidBodyFat: "Percentual de gordura inválido",
    invalidBodyFatDesc: "O percentual de gordura deve estar entre 3% e 60%.",
    generating: "Gerando Treino...",
    generatePlan: "Gerar Plano de Treino",
    workoutGenerated: "Treino Gerado! 💪",
    workoutGeneratedDesc: "Seu plano de treino personalizado está pronto.",
    noPlans: "Nenhum treino gerado ainda",
    noPlansDesc: "Preencha seus dados acima e clique em 'Gerar Plano de Treino' para criar seu primeiro workout personalizado com IA",
    active: "Ativo",
    planActivated: "Plano Ativado!",
    planActivatedDesc: "Este é agora seu plano de treino ativo.",
    planDeleted: "Plano Excluído!",
    planDeletedDesc: "O plano de treino foi removido com sucesso.",
    errorDeleting: "Erro ao excluir",
    rest: "Descanso",
    days: "dias",
    pinPlan: "Fixar plano",
    unpinPlan: "Desafixar plano",
    deletePlan: "Excluir plano",
    weightLoss: "Emagrecimento",
    muscleGain: "Hipertrofia",
  },
  // Analytics page
  analyticsPage: {
    title: "Analytics & Insights",
    subtitle: "Visualize sua evolução e conquistas",
    period: "Período:",
    selectPeriod: "Selecione o período",
    dataSince: "Dados desde:",
    startDate: "Data inicial",
    endDate: "Data final",
    to: "até",
    last7days: "Últimos 7 dias",
    last14days: "Últimos 14 dias",
    lastMonth: "Último mês",
    last3months: "Últimos 3 meses",
    last6months: "Últimos 6 meses",
    lastYear: "Último ano",
    thisYear: "Este ano",
    allHistory: "Todo o histórico",
    custom: "Personalizado",
    checkins: "Check-ins",
    avgWater: "Média Água",
    cups: "copos",
    avgCalories: "Média Calorias",
    currentWeight: "Peso Atual",
    mealPlans: "Planos Nutrição",
    workoutPlans: "Planos Treino",
    noData: "Sem dados para visualizar",
    noDataDesc: "Comece a fazer check-ins diários e registrar seu progresso para ver gráficos detalhados",
    noDataInPeriod: "Sem dados neste período",
    noDataInPeriodDesc: "Não há registros no período selecionado. Tente expandir o intervalo de datas.",
    viewAllHistory: "Ver todo histórico",
    overview: "Geral",
    weightTab: "Peso",
    waterTab: "Água",
    caloriesTab: "Calorias",
    moodTab: "Humor",
    hydration: "Hidratação",
    workoutFrequency: "Frequência de Treinos",
    moodDistribution: "Distribuição de Humor",
    weightEvolution: "Evolução de Peso",
    weightOverTime: "Acompanhe a variação do seu peso ao longo do tempo",
    bodyComposition: "Composição Corporal",
    fatPercent: "% Gordura",
    massKg: "Massa (kg)",
    calorieIntake: "Consumo Calórico",
    dailyCalories: "Calorias consumidas por dia",
    macroBreakdown: "Distribuição de Macros",
    avgMacros: "Média de macronutrientes no período",
    avgProtein: "Média Proteína",
    avgCarbs: "Média Carboidratos",
    avgFat: "Média Gordura",
    moodOverTime: "Humor ao Longo do Tempo",
    moodTrend: "Tendência do seu humor nos check-ins",
    trained: "Treinou",
    goal: "Meta",
  },
  // Landing page (Index)
  landing: {
    badge: "+10.000 usuários transformando seus corpos",
    headline1: "Seu Personal Trainer",
    headline2: "com IA.",
    headline3: "No seu bolso",
    headline4: "24/7",
    subheadline: "Planos de treino e alimentação 100% personalizados, gamificação que vicia e um coach de IA sempre disponível.",
    startNow: "Começar Agora",
    goToDashboard: "Ir para Dashboard",
    seeHowItWorks: "Ver como funciona",
    rating: "4.9/5 • 2.400+ avaliações",
    painTitle: "Chega de perder tempo com o que",
    painTitleFaded: "não funciona",
    painSubtitle: "Veja como o FitPro resolve cada problema",
    featuresTitle: "Tudo que você precisa.",
    featuresTitleHighlight: "Nada que não precisa.",
    featuresSubtitle: "Clique para explorar cada funcionalidade",
    stepsTitle: "3 passos.",
    stepsTitleFaded: "Zero complicação.",
    testimonialsTitle: "Histórias de",
    testimonialsTitleHighlight: "transformação",
    testimonialsSubtitle: "Resultados reais de pessoas reais",
    tiersTitle: "Até onde você vai chegar?",
    tiersSubtitle: "10 tiers para conquistar. De sedentário a imortal.",
    tiersPointsLabel: "pts",
    ctaTitle: "Pronto para",
    ctaTitleHighlight: "transformar seu corpo?",
    ctaSubtitle: "Junte-se a +10.000 pessoas que já estão usando IA para alcançar resultados reais.",
    ctaButton: "Começar Agora — É Grátis",
    faqTitle: "Perguntas",
    faqTitleHighlight: "frequentes",
    footerDesc: "Transforme seu corpo com inteligência artificial.",
    footerProduct: "Produto",
    footerLegal: "Legal",
    footerTerms: "Termos de Uso",
    footerPrivacy: "Política de Privacidade",
    footerRights: "Todos os direitos reservados.",
    features_ai: "IA que aprende com você",
    features_ai_desc: "Planos de treino e alimentação que evoluem junto com seu corpo e objetivos.",
    features_photo: "Foto → Calorias",
    features_photo_desc: "Tire uma foto da refeição e receba a análise nutricional instantaneamente.",
    features_gamification: "Gamificação & Rankings",
    features_gamification_desc: "Suba do 'Sedentário Arrependido' ao 'Imortal Fitness' com pontos e ranks.",
    features_challenges: "Desafios 1v1",
    features_challenges_desc: "Desafie amigos em batalhas fitness e prove quem é mais dedicado.",
    features_analytics: "Analytics completos",
    features_analytics_desc: "Gráficos detalhados de peso, calorias, treinos e progresso ao longo do tempo.",
    features_coach: "FitPro Coach 24/7",
    features_coach_desc: "Converse com seu coach de IA a qualquer hora. Tire dúvidas, peça ajustes nos planos.",
    features_ai_tag1: "Plano personalizado",
    features_ai_tag2: "Adapta ao progresso",
    features_ai_tag3: "Aprende seus hábitos",
    features_challenge_you: "Você",
    features_challenge_weekWorkouts: "Treinos na semana",
    extraWrapped: "Wrapped mensal",
    extraPWA: "Instale como app (PWA)",
    extraGoals: "Metas personalizadas",
    extraSubstitutions: "Substituições inteligentes",
    step1Title: "Faça o onboarding",
    step1Desc: "2 minutos para configurar seu perfil, objetivos e restrições.",
    step2Title: "Receba seu plano",
    step2Desc: "A IA gera planos de treino e alimentação 100% personalizados.",
    step3Title: "Treine e suba no ranking",
    step3Desc: "Execute, registre, ganhe pontos e conquiste tiers.",
    faqItems: [
      { q: "O que é o FitPro IA?", a: "É um app de saúde e fitness que usa inteligência artificial para criar planos de treino e alimentação 100% personalizados, com gamificação, desafios sociais e um coach virtual disponível 24/7." },
      { q: "Como a IA personaliza meus planos?", a: "No onboarding, você informa seus dados (peso, altura, objetivos, restrições). A IA usa essas informações para gerar planos únicos que se adaptam ao seu progresso." },
      { q: "Posso cancelar a qualquer momento?", a: "Sim! Sem contratos ou fidelidade. Cancele quando quiser pelo portal de gerenciamento de assinatura." },
      { q: "Funciona no iPhone e Android?", a: "Sim! O FitPro IA é um PWA que funciona em qualquer dispositivo — iPhone, Android e Desktop. Instale direto do navegador." },
      { q: "Preciso de experiência em academia?", a: "Não! O app se adapta ao seu nível, desde iniciante até avançado." },
      { q: "Como funciona a gamificação?", a: "Você ganha pontos por cada ação (treinos, check-ins, metas). Conforme acumula pontos, sobe de tier — do 'Sedentário Arrependido' até o 'Imortal Fitness'." },
    ],
    painPoints: [
      { pain: "Dietas genéricas que não funcionam", solution: "Planos alimentares personalizados pela IA" },
      { pain: "Treinos sem direção nem objetivo", solution: "Workouts adaptados ao seu nível e meta" },
      { pain: "Falta de motivação e consistência", solution: "Gamificação, streaks e desafios sociais" },
      { pain: "Personal trainer caro e horário fixo", solution: "Coach de IA disponível 24/7 por R$ 29,90/mês" },
    ],
    testimonials: [
      { name: "Carlos S.", result: "Perdeu 15kg em 4 meses", content: "O FitPro mudou minha vida! A IA realmente entende minhas necessidades e cria planos que funcionam de verdade.", rating: 5 },
      { name: "Ana Paula M.", result: "Ganhou 8kg de massa muscular", content: "Nunca imaginei que conseguiria resultados tão rápido. Os treinos são perfeitos pro meu nível.", rating: 5 },
      { name: "Roberto C.", result: "Mantém forma há 6 meses", content: "Mesmo com pouco tempo, consigo seguir a rotina. A gamificação é viciante!", rating: 5 },
      { name: "Juliana F.", result: "Perdeu 10kg pós-gestação", content: "O chat com o coach me ajudou muito nos dias difíceis. É como ter um personal disponível 24h.", rating: 5 },
    ],
    tiers: [
      { name: "Sedentário Arrependido", emoji: "🛋️", points: 0 },
      { name: "Iniciante Motivado", emoji: "🌱", points: 100 },
      { name: "Guerreiro do Sofá", emoji: "⚔️", points: 300 },
      { name: "Atleta de Fim de Semana", emoji: "🏃", points: 600 },
      { name: "Rato de Academia", emoji: "🐀", points: 1000 },
      { name: "Máquina de Treino", emoji: "🤖", points: 1500 },
      { name: "Titã do Fitness", emoji: "💪", points: 2200 },
      { name: "Lenda Viva", emoji: "🌟", points: 3000 },
      { name: "Semideus", emoji: "⚡", points: 4000 },
      { name: "Imortal Fitness", emoji: "👑", points: 5500 },
    ],
    coachQuestion: "Como ajustar meu treino para focar em hipertrofia?",
    coachAnswer: "Baseado no seu perfil, recomendo 4 séries de 8-12 reps com carga progressiva... 💪",
  },
};